import React, { createContext, useContext, useState, useEffect } from 'react';

const YearContext = createContext();

export function YearProvider({ children }) {
  const currentYear = new Date().getFullYear().toString(); // make it string
  const [year, setYear] = useState(() => {
    const stored = localStorage.getItem('selectedYear');
    return stored ? stored : currentYear;
  });

  useEffect(() => {
    if (year) {
      localStorage.setItem('selectedYear', year);
    }
  }, [year]);

  return (
    <YearContext.Provider value={{ year, setYear }}>
      {children}
    </YearContext.Provider>
  );
}


export function useYear() {
  return useContext(YearContext);
}
